module.exports = __webpack_public_path__ + "static/media/audiocall-background.275d8fc8.jpg";